import { ShieldCheck, ShieldAlert, Clock, ShieldOff } from 'lucide-react';

const STATUS_MAP: Record<string, { icon: typeof ShieldCheck; label: string; cls: string }> = {
  VERIFIED: { icon: ShieldCheck, label: 'NeoVerified', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  PENDING_NEOVERIFY: { icon: Clock, label: 'Pending', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  REVOKED: { icon: ShieldOff, label: 'Revoked', cls: 'bg-red-50 text-red-700 border-red-200' },
  SUPERSEDED: { icon: ShieldAlert, label: 'Superseded', cls: 'bg-gray-50 text-gray-500 border-gray-200' },
  EXPIRED: { icon: ShieldOff, label: 'Expired', cls: 'bg-gray-50 text-gray-500 border-gray-200' },
};

/**
 * The NeoVerify mark, and the id behind it.
 *
 * This took a `verifyUrl` that no endpoint on this platform has ever sent, so
 * the hover text was empty on every badge. What DOES exist is the NeoVerify
 * id — the thing a provider quotes or scans, and the thing the Verify a
 * document screen takes. So that is what the badge carries.
 */
export default function NeoVerifyBadge({
  status,
  neoVerifyId,
}: { readonly status: string; readonly neoVerifyId?: string | null }) {
  const s = STATUS_MAP[status] || STATUS_MAP['PENDING_NEOVERIFY'];
  const Icon = s.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-md border ${s.cls}`}
      title={neoVerifyId ? `NeoVerify id ${neoVerifyId}` : undefined}
    >
      <Icon className="w-3 h-3" />
      {s.label}
    </span>
  );
}
